import * as React from 'react';
import { fieldTypeLabel, UiField } from '../helpers/clubProgrammeFieldsEditor';
import { badge, renderEnumOptions } from '../helpers/clubProgrammeFieldsEditorUi';

type Props = {
  fields: UiField[];
};

export const ClubProgrammeFieldsList: React.FC<Props> = ({ fields }) => {
  return (
    <div className="mt-3">
      {fields.length === 0 ? (
        <div className="cpFieldsEmptyState">
          <div className="cpFieldsEmptyTitle">No booking fields added yet</div>
          <div className="cpFieldsEmptyText">
            Use <b>Manage fields</b> to choose which fields should appear on the programme booking form.
          </div>
        </div>
      ) : (
        <>
          {fields.map(f => {
            const t = fieldTypeLabel(f.type);
            const req = !!f.isRequired;

            return (
              <div key={f.id} className="cpProgrammeFieldCard">
                <div className="cpProgrammeFieldCardBody">
                  <div className="cpProgrammeFieldCardTitle" title={String(f.heading || '')}>
                    {String(f.heading || '—')}
                  </div>

                  <div className="cpBadges cpProgrammeFieldCardBadges">
                    {badge('info', t)}
                    {badge(req ? 'warn' : 'muted', req ? 'Required' : 'Optional')}
                    {t === 'ENUM' ? badge('muted', `${(f as any).enumOptions?.length || 0} options`) : null}
                  </div>

                  {t === 'ENUM' ? renderEnumOptions((f as any).enumOptions || []) : null}
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

ClubProgrammeFieldsList.displayName = 'ClubProgrammeFieldsList';
